import React, { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import Spinner from './Spinner';
import NoteContext from '../context/note/NoteContext.js';

const Login = (props) => {
    const [credentials, setCredentials] = useState({ email: "", password: "" })
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const context = useContext(NoteContext);
    const { textColor } = context;


    const handleSubmit = async (e) => {
        e.preventDefault();
        props.setProgress(10)
        setLoading(true);

        const response = await fetch(`${props.URI}/api/auth/login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ email: credentials.email, password: credentials.password }),
        });
        props.setProgress(25)
        const json = await response.json();
        props.setProgress(75)
        setLoading(false);
        props.setProgress(100)
        // console.log(json);

        if (json.success) {
            localStorage.setItem("token", json.authtoken);
            props.showAlert("success", "Login Successfully");

            // Check if the user is an admin
            if (json.isAdmin) {
                navigate("/admin");
            } else {
                navigate("/home");
            }


        }
        else {
            props.showAlert("danger", "Invalid Credentials");
        }
    }

    const onChange = (e) => {
        setCredentials({ ...credentials, [e.target.name]: e.target.value })
    }

    return (
        <div className='login container' style={{...textColor, marginTop: "75px"}}>
            {loading ? <Spinner /> :
                <div>
                    <h3>Login <i className="fa-solid fa-book-atlas"></i> Page</h3>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">Email address</label>
                            <input type="email" className="form-control" id="email" name='email' value={credentials.email} onChange={onChange} aria-describedby="emailHelp" required={true} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="password" className="form-label">Password</label>
                            <input type="password" className="form-control" id="password" name='password' value={credentials.password} onChange={onChange} required={true} />
                        </div>
                        <button disabled={credentials.email.length < 6 || credentials.password.length < 6} type="submit" className="btn btn-dark">Submit</button>
                    </form>
                </div>}
        </div>
    )
}

export default Login
